/**
 * 写接口幂等键（后端 `X-Request-Id`，落 `ops_idempotent`，DR-12.2）。
 * 每次“用户提交动作”生成一次，重试必须复用同一个值。
 */
let fallbackSeq = 0;

export function newRequestId(): string {
  const cryptoRef = (globalThis as {
    crypto?: { randomUUID?: () => string; getRandomValues?: (bytes: Uint8Array) => Uint8Array };
  }).crypto;
  if (typeof cryptoRef?.randomUUID === 'function') return cryptoRef.randomUUID();

  // RN/H5 老环境无 randomUUID 时优先用 CSPRNG：纯随机回退在跨用户并发下会撞键，
  // 撞键会被后端当成"重复提交"而回放他人响应体。
  if (typeof cryptoRef?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    cryptoRef.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }

  // 最后兜底：时间戳 + 进程内单调计数 + 随机段，尽量降低撞键概率
  fallbackSeq = (fallbackSeq + 1) % 0xffff;
  const rand = () => Math.random().toString(16).slice(2, 10);
  return `${Date.now().toString(16)}-${fallbackSeq.toString(16)}-${rand()}-${rand()}`;
}
